import { useEffect, useState } from 'react'

// Shared by the confirmation-card artifacts (bulk edit, report edit):
// their staged tokens expire server-side, so the card flips to an
// expired state at the same moment.
export function useExpiryCountdown(expiresAt: string): boolean {
  const [expired, setExpired] = useState(
    () => Date.parse(expiresAt) < Date.now(),
  )
  useEffect(() => {
    if (expired) return
    const remaining = Date.parse(expiresAt) - Date.now()
    if (remaining <= 0) {
      setExpired(true)
      return
    }
    const timer = window.setTimeout(() => setExpired(true), remaining)
    return () => window.clearTimeout(timer)
  }, [expiresAt, expired])
  return expired
}

export function formatExpiresAt(expiresAt: string): string {
  const ms = Date.parse(expiresAt) - Date.now()
  if (Number.isNaN(ms) || ms < 0) return 'soon'
  const minutes = Math.ceil(ms / 60_000)
  return `in ${minutes} ${minutes === 1 ? 'minute' : 'minutes'}`
}

const ONE_HOUR_MS = 60 * 60_000

// Report edit cards live for days, so the countdown only shows near the end.
export function expiresWithinAnHour(expiresAt: string): boolean {
  return Date.parse(expiresAt) - Date.now() < ONE_HOUR_MS
}
